// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationDocumentsConfigurationPage_container__1uCqT"};